export default __webpack_public_path__ + "static/media/Huge-Projects.2e522150.jpg";